export default __webpack_public_path__ + "static/media/Jasmeen.d9120ff7.jpg";